__turbopack_context__.v({
  "chevronRotated": "BGBKMW_chevronRotated",
  "distribution": "BGBKMW_distribution",
  "distributionHeader": "BGBKMW_distributionHeader",
  "drift": "BGBKMW_drift",
  "expandable": "BGBKMW_expandable",
  "innertable": "BGBKMW_innertable",
  "loaded": "BGBKMW_loaded",
  "loadingSpinner": "BGBKMW_loadingSpinner",
  "maintable": "BGBKMW_maintable",
  "rowexpand": "BGBKMW_rowexpand",
});
